export const HIRING_STEPS = [
  {
    icon: 'equifax-pointer-check',
    text: 'Selecione o valor da recarga'
  },
  {
    icon: 'equifax-purchase',
    text: 'Realize a compra'
  },
  {
    icon: 'equifax-restricted-access',
    text: 'Receba sua senha de acesso'
  },
  {
    icon: 'equifax-file-analysis',
    text: 'Pronto! Já pode consultar'
  }
]
